export default __webpack_public_path__ + "static/media/christmas.240892ea.zip";